import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ContaAppRoutingModule } from "./conta.app-routing.module";

@NgModule({
    imports: [
        CommonModule,
        ContaAppRoutingModule
    ]
})
export class ContaAppModule { }
